import React from 'react';
import {NavLink} from "react-router-dom";
import { useTranslation } from "react-i18next";

const CopyRightComponent = () => {
    const { t } = useTranslation();
    
    return (
        <div className="copyRightComponent__container">
            <div className="copyRightComponent__container-content">
                <div className="copyRightComponent__container-content-img-wrap">
                    <div className="headSectionHeader__container-logo-wondr copyright">
                        <img
                            className="headSectionHeader__container-logo-wondr-img copyright"
                            src={process.env.PUBLIC_URL + '/images/wondrLogoCopyright.svg'}
                            alt="wondr logo"
                        />
                    </div>
                    {/* <div className="headSectionHeader__container-logo-dining copyright">
                        <img
                            className="headSectionHeader__container-logo-dining-img copyright"
                            src={process.env.PUBLIC_URL + '/images/diningLogoCopyright.svg'}
                            alt="dining logo"
                        />
                    </div> */}
                </div>
                <div className="copyRightComponent__container-copyright-text-wrap">
                    <div className="copyRightComponent__container-copyright-text">
                        <span>{t('main.copyrightAllRightsReserved')}</span>
                    </div>
                    <div className="copyRightComponent__container-copyright-links">
                        <div className="copyRightComponent__container-copyright-link">
                            <NavLink to="/terms-of-use" >{t('main.termsOfUse')}</NavLink>
                        </div>
                        <div className="copyRightComponent__container-copyright-link">
                            <NavLink to="/cookies" >{t('main.cookies')}</NavLink>
                        </div>
                        <div className="copyRightComponent__container-copyright-link">
                            <NavLink to="/privacy-policy" >{t('main.privacyPolicy')}</NavLink>
                        </div>
                        <div className="copyRightComponent__container-copyright-link">
                            <NavLink to="/legal-notice" >{t('main.legalNotice')}</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CopyRightComponent;